import { render, staticRenderFns } from "./ResultadoExportacaoComSucesso.vue?vue&type=template&id=5c73d55e"
import script from "./ResultadoExportacaoComSucesso.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoExportacaoComSucesso.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports